module.exports = __webpack_public_path__ + "static/media/granola.64143859.jpg";